import { request } from "./apiClient";
import { assertSingleUploadSize } from "../lib/multipartUpload";

export const userService = {
  /**
   * POST /api/users/me/avatar — multipart field `avatar`.
   * @returns {Promise<{ message: string, user: object }>} user giống GET /auth/me (không có password)
   */
  uploadAvatar: async (token, file) => {
    assertSingleUploadSize(file); // BE giới hạn upload 1 request ~4.5MB (413)
    const fd = new FormData();
    fd.append("avatar", file);
    const res = await request("/users/me/avatar", {
      method: "POST",
      token,
      body: fd,
      isFormData: true,
    });
    return { message: res.message, user: res.data };
  },
};

